exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._mw-160[data-v-21d85d94]{max-width:120px}p[data-v-21d85d94]{font-size:18px;padding:5px 0;font-family:Helvetica!important}.mw-15-rem[data-v-21d85d94]{max-width:12rem;padding-right:6px}", ""]);

// exports
